/**
 * In opposite to other methods,
 * PATCH have to be uppercased:
 *
 * https://blog.k-nut.eu/patch-capitalization
 */

export enum RestApiMethodName {
    DELETE = 'DELETE',
    POST = 'POST',
    GET = 'GET',
    PUT = 'PUT',
    PATCH = 'PATCH',
}
